module.exports = __webpack_public_path__ + "static/media/Test40.58913418.bmp";